import { useMemo } from 'react';

import { LocationObject } from '@pflegia/types/common/location/location-object';

import { JobListProps } from '@domains/job-board';

import { useRouterHelper } from '@shared/hooks/use-router-helper';

import { JobBoardSeoContentProps } from './job-board-seo-content-props';

const useJobBoardSeoContent = (
  filterJobTitleIds: string[],
  filterLocations: (LocationObject | undefined)[],
  jobTitle?: JobListProps['jobTitle'],
  location?: JobListProps['location'],
): JobBoardSeoContentProps | undefined => {
  const { isTransparentPath } = useRouterHelper();
  const props = useMemo<JobBoardSeoContentProps | undefined>(() => {
    if (!isTransparentPath || filterJobTitleIds.length > 1 || filterLocations.length > 1) return;
    if (filterJobTitleIds.length === 1 && filterLocations.length === 1 && filterLocations[0]?.city) {
      return { city: filterLocations[0].city, jobTitleId: filterJobTitleIds[0] };
    }
    if (jobTitle && location?.city) {
      return { city: location.city, jobTitleId: jobTitle.id };
    }
  }, [filterJobTitleIds, filterLocations, isTransparentPath, jobTitle, location]);
  return props;
};

export default useJobBoardSeoContent;
